import { useState } from "react";
import { useLocation } from "react-router";
import { CircleHelp } from "lucide-react";
import { ajudaDaRota } from "@/lib/ajuda/rotas";
import { useIsMobile } from "@/lib/use-media-query";
import { ALTURA_DA_BARRA } from "@/components/layout/mobile/BarraDeAbas";
import { PainelDeAjuda } from "./PainelDeAjuda";
import { useAlturaDoRodape } from "./RodapeOcupado";

/**
 * "? Ajuda" fixo no canto de baixo — sempre à mão, sem rolar. No celular fica acima da barra de
 * abas; barra fixa de salvar/seleção empurra ele pra cima (RodapeOcupado). Some quando a rota não
 * tem ajuda (placeholder, legado).
 */
export function BotaoDeAjuda() {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const alturaOcupada = useAlturaDoRodape();
  const [aberto, setAberto] = useState(false);
  const ajuda = ajudaDaRota(pathname);
  if (!ajuda) return null;
  const base = isMobile ? `${ALTURA_DA_BARRA} + env(safe-area-inset-bottom) + 0.75rem` : "1rem";
  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        aria-label="Como funciona esta página"
        data-ajuda-da-pagina
        data-tour="botao-ajuda"
        style={{ bottom: `calc(${base} + ${alturaOcupada}px)` }}
        className="fixed right-4 z-30 inline-flex h-9 items-center gap-1.5 rounded-full border border-zinc-200 bg-white pl-2.5 pr-3.5 text-[13px] font-medium text-zinc-600 shadow-md transition-colors hover:bg-zinc-50 hover:text-zinc-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 dark:border-border dark:bg-card dark:text-muted-foreground dark:hover:text-foreground"
      >
        <CircleHelp className="h-4 w-4" />
        Ajuda
      </button>
      <PainelDeAjuda ajuda={ajuda} aberto={aberto} onAbertoChange={setAberto} />
    </>
  );
}
